import { useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { useCallback, useEffect, useState, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SearchableSelectField, OptionsList } from 'components/core/form';
import { userGroupsLoadingSelector, userGroupsSelector, userGroupsNextPageSelector } from './selectors';
import { fetchUserGroups, searchUserGroups } from './slice';
const optionsFooterCss = "o5mq3j2";
const OptionsFooter = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionsFooterCss, props.className)} />;
});
export const GroupSelect = ({
  onFocus
}) => {
  const dispatch = useDispatch();
  const userGroups = useSelector(userGroupsSelector);
  const options = userGroups.map(({
    id,
    name
  }) => ({
    id,
    name
  }));
  const isLoading = useSelector(userGroupsLoadingSelector);
  const hasMoreGroups = !!useSelector(userGroupsNextPageSelector);
  const {
    values: {
      existingGroupId
    }
  } = useFormContext();
  const [selectedGroup, setSelectedGroup] = useState(null);
  useEffect(() => {
    const userGroup = userGroups.find(({
      id
    }) => id === existingGroupId);
    if (userGroup) setSelectedGroup(userGroup);
  }, [userGroups, existingGroupId]);
  const handleSearch = useCallback(query => {
    dispatch(searchUserGroups(query));
  }, [dispatch]);
  const fetchNextPage = () => {
    dispatch(fetchUserGroups());
  };
  return <SearchableSelectField name="existingGroupId" aria-label={I18n.t('publisher.organization.members.add_to_group.select_group_placeholder')} displayValue={selectedGroup && selectedGroup.name} options={options} placeholder={I18n.t('publisher.organization.members.add_to_group.select_group_placeholder')} onSearch={handleSearch} onFocus={onFocus}>
      <OptionsList isLoading={isLoading} notFoundText={I18n.t('publisher.organization.members.add_to_group.no_groups_found')} />
      {hasMoreGroups && !isLoading && <OptionsFooter>
          <Button wide onClick={fetchNextPage}>{I18n.t('publisher.title.show_more')}</Button>
        </OptionsFooter>}
    </SearchableSelectField>;
};

require("./group_select.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./group_select.js");